var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "17.761 0 64.476 100",
    enableBackground: "new 17.761 0 64.476 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.494,17.445l1.184-4.138l-5.854-1.875l-1.918,5.289l-9.795-1.077c0.014-2.122-0.729-4.256-2.27-5.957 c-3.257-3.593-8.818-3.874-12.418-0.615c-1.479,1.34-2.387,3.067-2.73,4.885l-21.154-2.59c0.239-0.453,1.144-1.37,1.352-2.976 c0.099-0.786,0.254-1.987,0.586-4.574c0.332-2.584-1.192-4.611-3.963-3.511c-2.768,1.098-3.204,3.014-2.382,6.125 c0.791,3,1.22,5.878,3.443,6.366l-0.006,0.044l21.97,2.952c0.045,2.039,0.788,4.071,2.263,5.699c3.261,3.6,8.822,3.88,12.427,0.613 c1.119-1.013,1.916-2.248,2.389-3.578l9.146,1.344l-2.877,7.936l-15.339-0.743c-0.649-0.071-1.314-0.09-1.992,0.021 c-4.058,0.656-6.813,4.475-6.158,8.535l3.785,23.369c0.041,0.257,0.124,0.495,0.189,0.741l-0.649,19.637l-9.092,15.947l6.133,3.954 L55.24,83.326c0.451-0.707,0.711-1.534,0.736-2.37l0.396-12.022l2.481,7.646l-0.9,22.692l7.533,0.729l2.709-23.62 c0.053-0.611-0.021-1.211-0.215-1.796l-6.254-18.876l-3.343-20.65l11.113,0.25c0.024,0.002,0.055,0.002,0.08,0.002 c1.614,0,3.046-1.039,3.546-2.584l3.393-11.861l5.25,0.771l0.09-0.695l0.293-2.276l0.088-0.697L77.494,17.445z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/GOLF.7875a06d45d1128b7c259118e83eef90.svg";
export { ForwardRef as ReactComponent };